import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';
import useGlobalState from '../../../../Template/atoms/variables';
import { useEffect } from 'react';
import { sleep } from '../../../../helpers/misc';
import { getSystems } from '../../../helpers/apiCalls';
import { useTranslation } from 'react-i18next';
import useMaintenanceState from '../../../atoms/variables';
import { useMsal } from '@azure/msal-react';

const SystemsOutlet = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { plantId } = useParams();
  const { instance } = useMsal();

  const [notificationApi, contextHolder] = notification.useNotification();

  const { setPendingApiCalls } = useGlobalState();
  const { setSystems, chosenPlant } = useMaintenanceState();

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getSystems']));
      const responses = await Promise.all([getSystems(instance, { parent: plantId })]);

      setSystems(responses[0]);
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getSystems'));
    }
  };

  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  );
};

export default SystemsOutlet;
